import React, { useState, useEffect, useMemo } from 'react';
import { Button, DatePicker as _DatePicker, Form, Input, message, Radio, Space, Popover } from 'antd';
import BlockWrapper from '@/components/edit-activity-plan/block-wrapper';
import Container from '@/components/container';
import ActIntroduceEditor from '@/components/wangeditor-for-acore';
import SelectCategory from '@/components/edit-activity-plan/select-category';
import FileUpload from './fileUpload';
import ActivityDemoImg from './activity-demo-image';
import { validateBytesLength } from '@/common/validator';
import './index.less';
import ActMemberSetting from './act-member-setting';
import { useIsJingxiErp } from '@/apis/generic/mac/common/dept/jx/erp';
import moment from 'moment';
import { getQuery } from '@/common/utils';
import roomApis from '@/apis/room/index';
import { queryRoomMembers } from '@/apis/roomMember/queryRoomMembers';
import GotoDetailModal from './goto-detail-modal';
import { withRouter } from 'react-router-dom';
import goto from '@/common/goto';
import FixFooterBtns from '@/components/fix-footer-wrapper';
import { useSlideMenuCollapse } from '@/hooks/useSlideMenuCollapsedChange';
import { InfoCircleOutlined } from '@drip/drip-design-icons';
import apis from '@/pages/activity-manage/merchants/venue-detail/apis';
import { showUserVoice } from '@/components/userVoice';

const DatePicker: any = _DatePicker;

const formatTime = (value: number) => {
  return Math.floor(value / 1000) * 1000;
};

const initValues = {
  venderSendPromise: 1,
  channel: 0,
};

const disabledDate = (current: any) => {
  return current && current < moment().endOf('day').subtract(1, 'day');
};

function AcoreCreateRoomActivity(props: any) {
  const [roomId, setRoomId] = useState<string | null>(getQuery('roomId'));
  const [activityId, setActivityId] = useState<string | null>(getQuery('activityId'));

  const [roomInfo, setRoomInfo] = useState<any>({});
  const [member, setMember] = useState<{ erp: string; realName: string; isLeader: number }[]>([]);
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const [{ data = { data: 0 } }] = useIsJingxiErp();
  const [submitLoading, setSubmitLoading] = useState(false);

  const isEdit = useMemo(() => !!roomId, [roomId]);

  const endTimedisabledDate = (current: any) => {
    return current && current < moment(roomInfo.endTime).startOf('day');
  };

  useEffect(() => {
    if (!roomId) return;
    roomApis
      .getDetailByRoomId({ roomId: roomId })
      .then((res) => {
        // eslint-disable-next-line
        const { ret, data, msg } = res;
        if (ret != '0' || !data) {
          throw msg || '活动信息接口请求失败';
        }
        setRoomInfo(data);
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, [roomId]);

  useEffect(() => {
    if (!roomId) return;
    queryRoomMembers({ roomId: roomId })
      .then((res) => {
        // eslint-disable-next-line
        const { ret, data, msg } = res;
        if (ret != '0' || !data) {
          throw msg || '管理组成员接口请求失败';
        }
        setMember(data);
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, [roomId]);

  useEffect(() => {
    const value = Object.assign({}, initValues, roomInfo, { members: member });
    if (value.startTime) {
      value.startTime = moment(value.startTime);
      value.endTime = moment(value.endTime);
    }
    if (value.highStartTime) value.actHightTime = [moment(value.highStartTime), moment(value.highEndTime)];
    if (value.preStartTime) value.actPreTime = [moment(value.preStartTime), moment(value.preEndTime)];
    value.demoImg = { demoImgUrl: value.demoImgUrl, demoImgName: value.demoImgName };
    value.introFile = { introUrl: value.introUrl, introName: value.introName };
    value.category = value.category ? value.category.map((item: any) => Number(item)) : [];
    form.setFieldsValue(value);
  }, [roomInfo, member, form]);

  const submitForm = useMemo(() => {
    if (isEdit) return roomApis.updateActivity;
    return roomApis.createActivity;
  }, [isEdit]);

  const onFinish = (value: any) => {
    const query = Object.assign({}, value, { ...value.demoImg }, { ...value.introFile });
    query.startTime = formatTime(value.startTime.valueOf());
    query.endTime = formatTime(value.endTime.valueOf());

    if (value.actHightTime) {
      query.highStartTime = formatTime(value.actHightTime[0].valueOf());
      query.highEndTime = formatTime(value.actHightTime[1].valueOf());
      delete query.actHightTime;
    }
    if (value.actPreTime) {
      query.preStartTime = formatTime(value.actPreTime[0].valueOf());
      query.preEndTime = formatTime(value.actPreTime[1].valueOf());
      delete query.actPreTime;
    }
    query.category = query.category.toString();
    delete query.categoryName;
    query.members = query.members.map((ele: any) => ele.erp).toString();

    delete query.demoImg;
    delete query.introFile;

    if (isEdit) query.roomId = roomId;
    query.type = 2;

    message.loading('活动信息保存中...');
    setSubmitLoading(true);
    submitForm(query)
      .then((res) => {
        setSubmitLoading(false);
        // eslint-disable-next-line
        const { ret, msg, data } = res;
        if (ret != '0') {
          throw msg || '活动保存失败';
        }
        message.destroy();
        message.success('活动保存成功');
        if (!isEdit) {
          setRoomId(data.roomId);
          setActivityId(data.activityId);
          setVisible(true);
          showUserVoice?.('994'); //弹出用户之声
        } else {
          goto.myCreateActivityDetailMaterials(activityId).push();
        }
      })
      .catch((ex) => {
        message.destroy();
        message.error(ex);
      });
  };

  const cateStrikeJobId = useMemo(() => getQuery('cateStrikeJobId'), []);

  useSlideMenuCollapse();

  return (
    <Container margin={false} padding paddingSize="max" className="acore-create-room-activity">
      <BlockWrapper title={isEdit ? '编辑活动' : '创建活动'}>
        <Form validateTrigger="onChange" className="acore-create-room-activity-form" form={form} onFinish={onFinish}>
          <Form.Item label="活动管理组" name="members">
            <ActMemberSetting isEdit={isEdit} />
          </Form.Item>
          <Form.Item label="活动名称">
            <Space className="act-name-block">
              <Form.Item
                noStyle
                required
                validateFirst={true}
                name="roomName"
                validateTrigger="onBlur"
                rules={[
                  {
                    required: true,
                    message: '活动名称不能为空',
                  },
                  {
                    validator: (_, value) =>
                      validateBytesLength({ max: 50, min: 20, value: value, msg: '活动名称长度要求为20-50字符' }),
                  },
                  {
                    validator: (_, value) => {
                      return new Promise((resolve, reject) => {
                        const exp1 = /测试+/;
                        const exp2 = /test+/;
                        if (exp1.test(value) || exp2.test(value) || !isNaN(Number(value)))
                          return reject(
                            new Error('对不起，您输入的名称不符合活动名称规范，请参考名称示意格式重新输入活动名称。')
                          );
                        return resolve(1);
                      });
                    },
                  },
                  {
                    //关键词校验
                    validator: async (_, value) => {
                      const res: any = await apis.roomNameValidate({ roomName: value });
                      if (!res) throw new Error(' ');
                      if (res.ret === '0') {
                        if (res.data?.list?.length) {
                          let info: { [key: string]: any } = {};
                          res.data.list.map((item: any) => {
                            const { activityName, activityCreator, planCode, word } = item;
                            if (info[planCode]) {
                              info[planCode] = info[planCode] + '、' + word;
                            } else {
                              info[planCode] =
                                '“' + activityName + '（活动创建人：' + activityCreator + '；命中关键词：' + word;
                            }
                          });
                          let errorInfo = [];
                          for (let act in info) {
                            errorInfo.push(info[act] + '）' + '”');
                          }
                          throw new Error(
                            `该活动名称与主题活动${errorInfo.join(
                              '、'
                            )}相似，如与主题活动存在关联，需在主题活动下进行活动创建，如与主题活动无关，需修改活动名称，避免与主题活动名称存在重复性。`
                          );
                        }
                      } else {
                        throw new Error('稍后重试');
                      }
                    },
                  },
                ]}
              >
                <Input
                  style={{ width: 560 }}
                  placeholder="【活动关键词/品类】+时间+玩法/力度。示例：【时尚居家】520爆品会场"
                />
              </Form.Item>
              <span className="act-name-tip">
                活动名称长度要求为20-50字符，不得包含“测试”、“test”，不可为纯数字，请尽可能清晰描述活动名称。查看商家报名界面展示形式：
                <Popover
                  placement="bottom"
                  arrowPointAtCenter
                  overlayClassName="act-name-tip-popover"
                  content={
                    <img
                      width={1000}
                      src="//img30.360buyimg.com/pop/jfs/t1/40811/6/18995/97224/632054bdEd73ebb2f/02469a83c1bfe939.png"
                    />
                  }
                >
                  <InfoCircleOutlined />
                </Popover>
              </span>
            </Space>
          </Form.Item>
          {data.data === 1 && (
            <>
              <Form.Item
                label="京喜事业部活动等级"
                required
                rules={[
                  {
                    required: true,
                    message: '请选择京喜事业部活动等级',
                  },
                ]}
                name="jingxiActivityLevel"
                style={{ lineHeight: '32px' }}
              >
                <Radio.Group disabled={isEdit}>
                  <Space direction="vertical">
                    <Radio value="S">
                      S级活动：618/双十一/双十二/年货节/节点促销/拼购节/拼购日/CPS等平台大促型营销活动。
                      <span className="important info">商家报名S级活动需保证已缴纳活动保证金≥20000。</span>
                    </Radio>
                    <Radio value="A">
                      A级活动：今日必拼、9.9包邮、1元福利、名品清仓、工厂直供等平台栏目活动。
                      <span className="important info">商家报名A级活动需保证已缴纳活动保证金≥2000。</span>
                    </Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
              <div className="venderSendPromise">
                <Form.Item label="商家发货时效承诺" required name="venderSendPromise">
                  <Radio.Group disabled={isEdit}>
                    <Radio value={1}>启用</Radio>
                    <Radio value={0}>不启用</Radio>
                  </Radio.Group>
                </Form.Item>
                <span className="important info">启用该功能后，京喜商家报名该活动时，需要首先签署发货时效承诺书。</span>
              </div>
            </>
          )}

          <Form.Item label="活动节奏">
            <div className="time">
              <div className="act-time officials">
                <Form.Item noStyle shouldUpdate={(prevValue, curValue) => prevValue.endTime !== curValue.endTime}>
                  {({ getFieldValue }) => (
                    <Form.Item
                      label="活动正式时间"
                      required
                      name="startTime"
                      rules={[
                        {
                          validator: (_, value) => {
                            return new Promise((resolve, reject) => {
                              const endTime = getFieldValue('endTime');
                              if (!value) return reject(new Error('活动开始时间不能为空'));
                              if (endTime && formatTime(value.valueOf()) >= formatTime(endTime.valueOf()))
                                return reject(new Error('开始时间需早于结束时间'));
                              return resolve('');
                            });
                          },
                        },
                      ]}
                    >
                      <DatePicker
                        showNow={false}
                        showTime={{ defaultValue: moment(new Date().getHours() + 1, 'HH:00:00') }}
                        disabledDate={!isEdit ? disabledDate : () => false}
                      />
                    </Form.Item>
                  )}
                </Form.Item>
                <span style={{ padding: '0 8px', marginBottom: '24px' }}>至</span>
                <Form.Item noStyle shouldUpdate={(prevValue, curValue) => prevValue.startTime !== curValue.startTime}>
                  {({ getFieldValue }) => (
                    <Form.Item
                      name="endTime"
                      rules={[
                        {
                          validator: (_, value) => {
                            return new Promise((resolve, reject) => {
                              const startTime = getFieldValue('startTime');
                              if (!value) return reject(new Error('活动结束时间不能为空'));
                              if (startTime && formatTime(value.valueOf()) <= formatTime(startTime.valueOf()))
                                return reject(new Error('开始时间需早于结束时间'));
                              // 编辑活动时，活动结束时间只能向后推迟
                              if (isEdit && formatTime(value.valueOf()) < roomInfo.endTime)
                                return reject(new Error(`修改后的结束时间不能早于修改前的结束时间`));
                              return resolve('');
                            });
                          },
                        },
                      ]}
                    >
                      <DatePicker
                        showTime={{ defaultValue: moment('23:59:59', 'HH:mm:ss') }}
                        showNow={false}
                        disabledDate={isEdit ? endTimedisabledDate : () => false}
                      />
                    </Form.Item>
                  )}
                </Form.Item>

                <span className="important info">
                  活动结束后将自动驳回素材。创建活动后，如需修改结束时间，修改后的结束时间只能晚于修改前的结束时间
                </span>
              </div>

              <Form.Item
                noStyle
                shouldUpdate={(prevValue, curValue) =>
                  prevValue.startTime !== curValue.startTime || prevValue.endTime !== curValue.endTime
                }
              >
                {({ getFieldValue }) => (
                  <>
                    <div className="act-time">
                      <Form.Item
                        label="活动预热时间"
                        name="actPreTime"
                        rules={[
                          {
                            validator: (_, value) => {
                              const startTime = getFieldValue('startTime');
                              return new Promise((resolve, reject) => {
                                if (!value || !value.length) resolve('');
                                if (formatTime(value[0].valueOf()) >= formatTime(value[1].valueOf())) {
                                  return reject(new Error('开始时间需晚于结束时间'));
                                }
                                if (startTime && formatTime(value[1].valueOf()) >= formatTime(startTime.valueOf())) {
                                  return reject(new Error('活动预热结束时间需早于活动正式开始时间'));
                                }
                                return resolve('');
                              });
                            },
                          },
                        ]}
                      >
                        <DatePicker.RangePicker
                          showTime={{
                            defaultValue: [
                              moment(new Date().getHours() + 1, 'HH:00:00'),
                              moment('23:59:59', 'HH:mm:ss'),
                            ],
                          }}
                          disabledDate={disabledDate}
                        />
                      </Form.Item>
                      <span className="info">促销活动未正式开始，展示预告价的时间段</span>
                    </div>
                    <Form.Item
                      label="活动高潮时间"
                      name="actHightTime"
                      rules={[
                        {
                          validator: (_, value) => {
                            const startTime = getFieldValue('startTime');
                            const endTime = getFieldValue('endTime');
                            return new Promise((resolve, reject) => {
                              if (!value || !value.length) return resolve('');
                              if (formatTime(value[0].valueOf()) >= formatTime(value[1].valueOf())) {
                                return reject(new Error('开始时间需晚于结束时间'));
                              }
                              if (startTime && formatTime(value[0].valueOf()) < formatTime(startTime.valueOf())) {
                                return reject(new Error('活动高潮开始时间要晚于活动正式开始时间'));
                              }
                              if (endTime && formatTime(value[1].valueOf()) > formatTime(endTime.valueOf())) {
                                return reject(new Error('活动高潮结束时间不能晚于活动正式结束时间'));
                              }
                              return resolve('');
                            });
                          },
                        },
                      ]}
                    >
                      <DatePicker.RangePicker
                        showTime={{
                          defaultValue: [moment(new Date().getHours() + 1, 'HH:00:00'), moment('23:59:59', 'HH:mm:ss')],
                        }}
                        disabledDate={disabledDate}
                      />
                    </Form.Item>
                  </>
                )}
              </Form.Item>
            </div>
          </Form.Item>
          <div className="benefits-introduction">
            <Form.Item
              style={{ width: '75%' }}
              required
              label="活动权益简介"
              validateFirst={true}
              validateTrigger="onBlur"
              name="benefitsIntroduction"
              rules={[
                {
                  required: true,
                  message: '活动权益简介不能为空',
                },
                {
                  validator: (_, value) =>
                    validateBytesLength({ max: 90, min: 0, value: value, msg: '活动权益简介长度不超过90字符' }),
                },
              ]}
            >
              <Input placeholder="活动权益简介长度不超过90字符。将展示在商家与采销的活动报名列表，请尽可能简洁地描述活动的背景与能给商家带来的权益，从而吸引商家/采销报名。" />
            </Form.Item>
            <span className="benefits-introduction-info">
              <Popover
                placement="bottom"
                arrowPointAtCenter
                overlayClassName="act-name-tip-popover"
                content={
                  <img
                    width={500}
                    src="//img30.360buyimg.com/pop/jfs/t1/66829/19/19133/59283/642bfd30F6594c693/db2374e2b9fda1d7.png"
                  />
                }
              >
                查看商家报名界面展示形式 <InfoCircleOutlined />
              </Popover>
            </span>
          </div>
          <Form.Item label="活动介绍" required wrapperCol={{ span: 18 }}>
            <div className="description-info">支持从邮件word中拷贝文字，支持上传图片</div>
            <Form.Item name="description" rules={[{ required: true, message: '活动介绍不能为空' }]}>
              {/** @ts-ignore */}
              <ActIntroduceEditor height={300} placeholder="请输入正文" />
            </Form.Item>
          </Form.Item>
          <Form.Item
            label="活动主要利益点"
            required
            rules={[
              { required: true, message: '利益点不能为空' },
              { max: 50, message: '活动主要利益点不能超过50字' },
            ]}
            name="profit"
            wrapperCol={{ span: 18 }}
          >
            <Input placeholder="样例：清凉饮料满199减100（不超过50字）" />
          </Form.Item>
          <div className="select-category">
            <SelectCategory
              label="行业分组"
              name="category"
              required
              rules={[{ required: true, message: '请选择行业分组' }]}
              categoryType="all"
              placeholder="请选择"
            />
            <span className="info">为商家筛选使用，请认真选择。</span>
          </div>
          <Form.Item label="活动渠道" required name="channel">
            <Radio.Group disabled={isEdit}>
              <Radio value={0}>默认</Radio>
              <Radio value={1}>
                京喜
                <span style={{ marginLeft: 20 }} className="info">
                  京喜渠道的活动，将会在京喜的独立报名入口内展示
                </span>
              </Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item className="act-demo-img" label="活动DEMO图" name="demoImg">
            <ActivityDemoImg />
          </Form.Item>
          <div className="activity-URL">
            <Form.Item
              label="活动页URL"
              name="showUrl"
              rules={[
                {
                  validator: (_, value) =>
                    validateBytesLength({ max: 500, value: value, msg: '活动页URL不能超过500个字符' }),
                },
                {
                  validator: (_, val) => {
                    return new Promise((resolve, reject) => {
                      // 校验活动页URL是否含有   pro.jd.com/mall/active/  pro.m.jd.com/wq/active/   pro.yhd.com/yhd/active/  sale.jd.com
                      const babelUrlRegExp =
                        '^https://((pro.m.jd)|(pro.yhd)|(pro.jd)|(prodev.m.jd)|(prodev.jd)|(sale.jd)).com|h5.m.jd.com/(babelDiy|rn|(((wq|pc)/)*?dev))';
                      if (val) {
                        const reg = new RegExp(babelUrlRegExp, 'g');
                        if (!reg.test(val)) {
                          return reject(new Error('要求为通天塔或智铺链接'));
                        }
                      }
                      return resolve(1);
                    });
                  },
                },
              ]}
            >
              <Input placeholder="请输入通天塔或智铺活动页URL，不能超过500个字符" />
            </Form.Item>
            <span className="info">便于报名人查看，可上传正式活动地址或预览地址</span>
          </div>
          <Form.Item
            label="活动展示位置"
            name="showLocation"
            wrapperCol={{ span: 18 }}
            rules={[{ max: 50, message: '活动展示位置不能超过50字' }]}
          >
            <Input placeholder="样例：主会场投放在JD首焦第一帧，美妆分会场投放在JD全球购首页右侧边栏（不超过50字）" />
          </Form.Item>
          <Form.Item label="活动详情介绍" name="introFile">
            <FileUpload />
          </Form.Item>
          <Form.Item
            label="发起活动部门简介"
            name="deptDesc"
            wrapperCol={{ span: 18 }}
            rules={[{ max: 50, message: '发起活动部门简介不能超过500字' }]}
          >
            <Input.TextArea
              rows={4}
              placeholder="样例：京东平台运营部，自2020年以来每年承担京东最重要的618、双11大促活动。（不超过500字）"
            />
          </Form.Item>
          <Form.Item>
            <FixFooterBtns>
              <Button type="primary" htmlType="submit" style={{ marginRight: 30 }} loading={submitLoading}>
                {isEdit ? '保存设置' : '创建活动'}
              </Button>
              <Button
                onClick={() =>
                  isEdit ? props.history.go(-1) : props.history.push('/activity-manage/myCreate/room/activityReceipt')
                }
              >
                取消
              </Button>
            </FixFooterBtns>
          </Form.Item>
          <Form.Item hidden name="extMap" initialValue={cateStrikeJobId ? { cateStrikeJobId } : {}} />
        </Form>
        <GotoDetailModal roomId={roomId} visible={visible} activityId={activityId} />
      </BlockWrapper>
    </Container>
  );
}

export default withRouter(AcoreCreateRoomActivity);
